import { post, get } from '../tools/http';

const loadWebinarsWithStatus = async (userId, status) => {
    const query = `user_id=${userId}&state=${status}`;
    const postParams = [
        'integrations',
        'proxy',
        {
            "service": "lms",
            "method": "GET",
            "is_response_required": true,
            "is_response_body_required": true,
            "path": `/api/webinar.user_webinars?${query}`,
        },
        true,
    ];
    const res = await post(...postParams);
    if (res
        && res.response_code < 300
        && res.payload
        && res.payload.data
    ) {
        return res.payload.data;
    } else {
        return [];
    }
};

export default {
    state: {
        trainingInvites: [],
        myCourses: [],
        pastWebinars: [],
        upcomingWebinars: [],
    },
    mutations: {
        writeRecommendedCourses: (state, value) =>
            state.recommendedCourses = value,

        writeRecommendedWebinars: (state, value) =>
            state.recommendedWebinars = value,

        writeMyCourses: (state, value) => state.myCourses = value,
        writeUpcomingWebinars: (state, value) => state.upcomingWebinars = value,
        writePastWebinars: (state, value) => state.pastWebinars = value,
        writeTrainingInvites: (state, value) => state.trainingInvites = value,
    },
    actions: {
        loadMyCourses: async ctx => {
            const postParams = [
                'integrations',
                'proxy',
                {
                    "service": "lms",
                    "method": "GET",
                    "is_response_required": true,
                    "is_response_body_required": true,
                    "path": `/api/course.get_user_progresses?id=${ctx.rootGetters.user.id}`,
                },
                true,
            ];
            const resMyCourses = await post(...postParams);
            if (resMyCourses
                && resMyCourses.response_code < 300
                && resMyCourses.payload
                && resMyCourses.payload.data
            ) {
                const myCoursesLMS = resMyCourses.payload.data;

                const myCourses = myCoursesLMS.map((course) => {

                    let progress = 0;
                    let status = course.completion_status;
                    if (course.type == 'scorm') {
                        let v = parseFloat(course.progress_measure);
                        if (!isNaN(v)) {
                            progress = Math.round(v);
                        } else {
                            progress = null;
                        }
                    } else {
                        progress = Math.round((course.count_complete_lessons
                            ? course.count_complete_lessons / course.lessons_count
                            : 0) * 100);
                        if (progress == 100) {
                            status = 'done';
                        }
                    }

                    return {
                        description: {
                            preview: course.background_image
                                ? course.background_image.url
                                : null,
                            theme: course.title,
                            description: course.description,
                            link: `https://lms.${window.rsvDomain}/courses/${course.id}/page`,
                        },
                        progress: {
                            status,
                            progress,
                            lessons: course.count_complete_lessons,
                            lessonsTotal: course.lessons_count,
                            points: course.points,
                            pointsTotal: course.max_available_points,
                            startTime: 0,
                        },
                    };
                });
                ctx.commit('writeMyCourses', myCourses);
            } else {
                ctx.commit('writeMyCourses', []);
            }
        },
        loadMyWebinars: async ctx => {
            const userId = ctx.rootGetters.user.id;
            const statuses = [
                'confirmed',
                'participated',
                'finished',
            ];
            let proloadLmsWebinars = await Promise.all(statuses
                .map((status) => loadWebinarsWithStatus(userId, status)));
            let webinars = proloadLmsWebinars
                .map((v, i) => {
                    if (Array.isArray(v.list)) {
                        return v.list.map((v) => ({
                            ...v,
                            state: statuses[i],
                            start_date:  (new Date(v.start_date)).getTime() / 1000,
                        }));
                    } else {
                        return [];
                    }
                })
                .reduce((acc, elem) => { 
                    return [...acc, ...elem];
                }, [])
                .reduce((acc, webinar) => {
                    let status = null;
                    let now = Date.now() / 1000;

                    if (webinar.bbb_meeting_created == 1) {
                        if (webinar.bbb_is_finished == 1) {
                            status = 'past';
                        } else if (now > webinar.start_date) {
                            status = 'now';
                        } else {
                            status = 'begins';
                        }
                    } else {
                        if (now > webinar.start_date) {
                            status = 'past';
                        } else {
                            status = 'future';
                        }
                    }

                    acc[status].push({
                        id: webinar.id,
                        external_id: webinar.external_id,
                        state: webinar.state,
                        status: status,
                        description: {
                            preview: webinar.cover
                                ? webinar.cover.url
                                : null,
                            theme: webinar.name,
                            description: webinar.description,
                            link: null,
                            start_date: webinar.start_date,
                        },
                    });
                    return acc;
                }, { past: [], now: [], begins: [], future: [] });
                
            let eventWebinars = (await get('event', 'event/all?filter[self]=1')).events
                .reduce((acc, webinar) => {
                    let status = null;
                    let now = new Date();
                    const datetimeEnd = new Date(webinar.datetimeEnd);
                    const datetimeBegin = new Date(webinar.datetimeBegin);
                    const datetimePre = new Date(datetimeBegin.getTime() - 60000 * 15);
                    
                    // console.log('now ' + new Date(now));
                    // console.log('datetimePre ' + new Date(datetimePre));
                    // console.log('datetimeBegin ' + new Date(datetimeBegin));
                    // console.log('datetimeEnd ' + new Date(datetimeEnd));
                    // console.log(' ');

                    if (now > datetimeEnd) {
                        status = 'past';
                    } else if ((datetimeBegin < now) && (now <= datetimeEnd)) {
                        status = 'now';
                    } else if ((datetimePre < now) && (now <= datetimeBegin)) {
                        status = 'begins';
                    } else if (now <= datetimePre) {
                        status = 'future';
                    }
                    acc[status].push({
                        id: webinar.id,
                        external_id: webinar.external_id,
                        state: webinar.foreignCmsId,
                        status: status,
                        key: 'event-webinar',
                        description: {
                            preview: webinar.cover
                                ? webinar.cover.url
                                : null,
                            theme: webinar.name,
                            description: webinar.description,
                            link: webinar.eventSiteUrl,
                            start_date: Date.parse(webinar.datetimeBegin) / 1000,
                        },
                    });
                    return acc;
                       
                }, { past: [], now: [], begins: [], future: [] });
            ctx.commit('writeUpcomingWebinars', [
                ...([
                    ...webinars['now'], 
                    ...webinars['begins'], 
                ].sort((a, b) => {
                    return a.description.start_date - b.description.start_date;
                })),
                ...(webinars['future'].sort((a, b) => {
                    return a.description.start_date - b.description.start_date;
                })),
                ...([
                    ...eventWebinars['now'], 
                    ...eventWebinars['begins'], 
                ].sort((a, b) => {
                    return a.description.start_date - b.description.start_date;
                })),
                ...(eventWebinars['future'].sort((a, b) => {
                    return a.description.start_date - b.description.start_date;
                })),
            ]);
            ctx.commit('writePastWebinars', 
                [
                    ...(webinars['past'].sort((a, b) => {
                        return b.description.start_date - a.description.start_date;
                    })),
                    ...(eventWebinars['past'].sort((a, b) => {
                        return b.description.start_date - a.description.start_date;
                    })),
                ]
            );
        },

        setEventWebinarCompleteStatus: async (ctx, eventWebinarId) => {
            post('event', 'participant/event/status/completed', { event: eventWebinarId }, true);
        },

        loadTrainingInvites: async ctx => {
            const userId = ctx.rootGetters.user.id;
            let webinars = await loadWebinarsWithStatus(userId, 'invited');

            webinars = webinars.list ? webinars.list
                .map((webinar) => {
                    // webinar.start_date = (new Date(webinar.start_date))
                    //     .getTime() / 1000;
                    return {
                        id: webinar.id,
                        external_id: webinar.external_id,
                        bbb_playbackurl: webinar.bbb_playbackurl,
                        description: {
                            preview: webinar.cover
                                ? webinar.cover.url
                                : null,
                            theme: webinar.name,
                            description: webinar.description,
                            link: null,
                            start_date: webinar.start_date,
                        },
                    };
                }) : [];
            ctx.commit('writeTrainingInvites', webinars);
        },
        async responseWebinarInvite(ctx, { external_id, confirm }) {
            const user = ctx.rootGetters.user;
            const postParams = [
                'integrations',
                'proxy',
                {
                    "service": "lms",
                    "method": "POST",
                    "body": {
                        "users": [{
                            email: user.user_email,
                            first_name: user.name,
                            last_name: user.surname,
                            external_id: user.id,
                        }],
                        "state": confirm ? 'confirmed' : 'declined',
                        "webinar": external_id,
                    },
                    "is_response_required": true,
                    "is_response_body_required": true,
                    "path": `/api/webinar.set_progress`,
                },
                true,
            ];
            let res = (await post(...postParams)).payload;
            if (res.status === "ok") {
                ctx.commit(
                    'writeTrainingInvites',
                    ctx.state.trainingInvites
                        .filter(v => v.external_id != external_id),
                );
                ctx.dispatch('loadMyWebinars');
            }
            return res.status === "ok";
        },
        async getWebinarStreamLink(ctx, webinar_id) {
            const user = ctx.rootGetters.user;
            const postParams = [
                'integrations',
                'proxy',
                {
                    "service": "lms",
                    "method": "POST",
                    "body": {
                        "webinar": webinar_id,
                        "external_id": user.id,
                    },
                    "is_response_required": true,
                    "is_response_body_required": true,
                    "path": `/api/webinar.join`,
                },
                true,
            ];
            let res = (await post(...postParams)).payload;
            if (res.status === "ok") {
                return res.data.link;
            }
        },
    },
    getters: {
        myCourses: state => state.myCourses,
        upcomingWebinars: state => state.upcomingWebinars,
        pastWebinars: state => state.pastWebinars,
        myTrainingInvites: state => state.trainingInvites,

        upcomingCourses: state => state.myCourses
            .filter((v) => v.progress.status !== 'done'),
        pastCourses: state => state.myCourses
            .filter((v) => v.progress.status === 'done'),
    },
};

// const getDateWithoutTimeZone = (isoString) => {
//     // let newIsoString = isoString.split('+')[0];
//     // const d = new Date(isoString).toLocaleString("en-US", {timeZone: "Europe/Moscow"});
//     // console.dir(d);
//     // let newDate = d(newIsoString);
//     // return Date.parse(d) / 1000;
//     let newDate = new Date(isoString.split('+')[0]+'+03:00');
//     let ParseDate = Date.parse(newDate);
//     return ParseDate;
// };
